import { render } from "./PatientEdit.vue?vue&type=template&id=5f2680ea"
import script from "./PatientEdit.vue?vue&type=script&lang=js"
export * from "./PatientEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__